export const NB_PARTNER_SITE_DATA = [
    {
        'name': 'Kickoff',
        'data': [
            5,
            3,
            0,
            0,
            6,
            9,
            0,
            0,
            17,
            2,
            1,
            1,
            11,
            4,
            3,
            0,
            0,
            0,
            3,
            2,
            3,
            3,
            1,
            2,
            0,
            2,
            2,
            1,
            0,
            0,
            0,
            0,
            3,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            2,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        'name': 'Hold',
        'data': [
            2,
            1,
            1,
            1,
            1,
            0,
            0,
            0,
            6,
            1,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            0,
            3,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            5,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        'name': 'Design Review',
        'data': [
            1,
            0,
            0,
            0,
            6,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4,
            0,
            0,
            3,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        'name': 'End Of Life',
        'data': [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        'name': 'Pre Sale',
        'data': [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        'name': 'Mass Production',
        'data': [
            302,
            314,
            147,
            151,
            107,
            101,
            117,
            113,
            79,
            94,
            94,
            74,
            63,
            58,
            59,
            55,
            47,
            54,
            37,
            39,
            29,
            31,
            29,
            16,
            20,
            14,
            8,
            11,
            15,
            14,
            13,
            12,
            9,
            3,
            10,
            8,
            9,
            9,
            9,
            9,
            5,
            0,
            7,
            7,
            5,
            5,
            7,
            6,
            3,
            6,
            6,
            4,
            5,
            5,
            4,
            4,
            1,
            4,
            0,
            1,
            3,
            2,
            1,
            1,
            1,
            1,
            2,
            2,
            1,
            2,
            0,
            0,
            2,
            2,
            2,
            2,
            2,
            2,
            1,
            1,
            0,
            1,
            1,
            0,
            1,
            1
        ]
    },
    {
        'name': 'Qualification',
        'data': [
            12,
            0,
            17,
            1,
            14,
            12,
            1,
            0,
            5,
            1,
            2,
            3,
            2,
            2,
            4,
            5,
            7,
            1,
            5,
            2,
            7,
            0,
            0,
            3,
            0,
            2,
            6,
            0,
            0,
            0,
            0,
            1,
            0,
            8,
            0,
            0,
            0,
            0,
            0,
            0,
            2,
            6,
            0,
            0,
            1,
            0,
            0,
            0,
            3,
            0,
            0,
            1,
            0,
            0,
            1,
            0,
            3,
            0,
            4,
            2,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            1,
            0,
            0
        ]
    }
]
export const NB_PARTNER_SITE_CATEGORIES = [
    'ASUS Notebook',
    'Microstar Notebook',
    'Compal - ACER Notebook',
    'Quanta - HP Notebook',
    'Compal - Dell Notebook',
    'LCFC - Lenovo Notebook',
    'CLEVO Notebook',
    'Gigabyte Notebook',
    'Wistron - Dell Notebook',
    'Compal - HP Notebook',
    'Quanta - ASUS Notebook',
    'Compal - Alienware Notebook',
    'Tongfang Notebook',
    'Inventec - Asus Notebook',
    'Quanta Notebook',
    'LCFC - Lenovo Thinkpad Notebook',
    'ADLink Quadro Embedded',
    'BYD - Razer Notebook',
    'Quanta - ACER Notebook',
    'Compal - Lenovo Notebook',
    'Quanta - HP AIO',
    'Inventec - HP Notebook',
    'Wistron - Lenovo Notebook',
    'Huaqin - Lenovo Notebook',
    'Pegatron Notebook',
    'PCPartner-Embedded-GPU',
    'Bitland SZ - Xiaomi Notebook',
    'Huaqin - Xiaomi Notebook',
    'Pegatron - Dell Notebook',
    'Samsung Notebook',
    'Wistron - ACER Notebook',
    'Bitland SZ - Lenovo Notebook',
    'Inventec - HP AIO',
    'Huaqin - Asus Notebook',
    'Quanta - Huawei Notebook',
    'Wistron - HP Notebook',
    'Pegatron - ASUS Notebook',
    'PCPartner - AIO_SFF',
    'Inventec - ACER Notebook',
    'Huaqin - Acer Notebook',
    'PNY Embedded Notebook',
    'PNY - Wolf Embedded',
    'Pegatron - Dell AIO',
    'MSI - HP Workstation',
    'Lengda - Tongfang Notebook',
    'Inventec - Xiaomi Notebook',
    'AVC - Lenovo AIO',
    'Wistron - Xiaomi Notebook',
    'Pegatron - Surface Notebook',
    'LG Notebook',
    'Huaqin - Huawei Notebook',
    'Advantech Quadro Embedded',
    'Quanta - Fujitsu Notebook',
    'Huaqin - Samsung Notebook',
    'Huaqin - Honor Notebook',
    'Wingtech-Asus Notebook',
    'PNY - EIZO Embedded',
    'Pegatron - Alienware Notebook',
    'Bitland SZ - Tongfang Notebook',
    'USI - Lenovo AIO',
    'Quanta - Lenovo Notebook',
    'Quanta - Honor Notebook',
    'LCFC - Lenovo AIO',
    'Wistron - Dell AIO',
    'Wistron - Acer AIO',
    'Wingtech - Huawei Notebook',
    'Surface Notebook',
    'Quanta - Xiaomi Notebook',
    'Quanta - LG Notebook',
    'Quanta-Colorful AIO',
    'PNY - Matrox Embedded',
    'Pegatron - Surface Desktop',
    'Pegatron - Medion Notebook',
    'Inventec - Dynabook Notebook',
    'Hasee Notebook',
    'ECS - Dell Notebook Workstation',
    'Compal - Lenovo AIO',
    'Compal - Asus AIO',
    'Pegatron - LG Notebook',
    'Pegatron - Intel AIO_SFF',
    'Mercury Systems Embedded',
    'LG AIO',
    'Lengda - Acer AIO',
    'BYD-Colorful AIO',
    'Asus OEM AIO',
    'Abaco Notebook'
]
export const NB_TRENDLINE_DATA = [
    {
        'data': [
            67120,73000,72810,80140,88030,79250,76010,76010,75000,72730,65160,65800,59060,51870,41610,33460,25000,23070,19540,19850
        ],
        'name': 'Hours Consumed'
    },
    {
        'data': [
            -14120,-21000,-20810,-28140,-36030,-26250,-19010,-19010,-18000,-15730,-8160,-6800,-60,7130,17390,25540,34000,35930,43460,45150

        ],
        'name': 'Hours Remaining'
    },
    {
        'data': [
            52000,52000,52000,52000,52000,52000,57000,57000,65000,57000,57000,59000,59000,59000,59000,59000,59000,59000,63000,65000
        ],
        'name': 'Max Capacity Hours'
    },
]
export const NB_TRENDLINE_CATEGORIES = [
    '6/22/2021','7/5/2021','7/16/2021','8/9/2021','8/24/2021','9/9/2021','9/27/2021','10/18/2021','11/8/2021','11/22','12/6','12/14','1/4','1/18','2/10','3/9','3/30','4/13','4/29','5/27'
]